import client from "utils/api";
import store from 'utils/store'
import analytics from 'utils/analytics'

function loadTotalCollaborators(){
  return client().get("/users/me/collaborators")
    .then((response) => {
      return response.data
    })
    .catch(e => {
      store.dispatch({type:"ADD_TOAST", message:"There was a problem connecting to the server."})

    });
}
function removeCollaborator(account_id, model){
  return client().post("accounts/"+account_id+"/collaborators/remove", {id:model._id})
    .then((response) => {
      return response.data
    })
    .catch(e => {
      //console.log("==>", e.response)
      store.dispatch({type:"ADD_TOAST", message:"There was a problem connecting to the server."})
    });
}

function addCollaborator(account, model){
  return client().post("accounts/"+account.id+"/collaborators", model)
    .then((response) => {
      analytics.track("add_collaborator")
      return response.data
    })
    .catch(e => {
      store.dispatch({type:"ADD_TOAST", message:"There was a problem connecting to the server."})

    });
}

function deleteAccount(account_id){
  return client().delete("accounts/"+account_id)
  .then((response)=>{
    return response.data
  })
}
function pauseAccount(account_id, pause){
  return client().put("accounts/"+account_id, {paused_at:pause})
  .then((response)=>{
    return response.data
  })
}


export default {
  loadTotalCollaborators,
  addCollaborator,
  removeCollaborator,
  deleteAccount,
  pauseAccount
}



// WEBPACK FOOTER //
// ./src/components/account_page/settings/api.js